// extracted by mini-css-extract-plugin
export var expandIcon = "fx_vC";
export var rotated = "fx_vD";